import React, { useEffect } from 'react';
import { track } from '@lf/analytics-events';

function SubscriptionActionBanner({ subscriptionAction, isLinked }) {
    const action = subscriptionAction?.action;

    // The self-serve expiry paywall (Subscribe + link a parent) for 13+
    // unlinked students is rendered globally by TrialBanner so it shows on
    // every page, not just the feed. Returning null here prevents a second,
    // contradictory "ask your parent" banner from stacking under it on the
    // feed. The "ask your parent" copy in the switch below is only correct
    // for LINKED children (whose parent's plan lapsed).
    if (!isLinked && (action === 'create_new' || action === 'create_new_has_canceled')) {
        return null;
    }

    // Self-subscribe (unlinked) students manage their own billing, so a failed
    // payment must offer a working self-serve portal link rather than the
    // "ask your parent" message (they have no parent to ask).
    if (!isLinked
        && (action === 'update_payment_past_due' || action === 'update_payment_unpaid')
        && subscriptionAction?.billing_portal_url) {
        const selfMessage = action === 'update_payment_past_due'
            ? 'Your subscription payment is past due. Update your payment method to keep learning.'
            : 'Your subscription is unpaid. Update your payment method to keep learning.';
        return <UpdatePaymentBanner
            message={selfMessage}
            url={subscriptionAction.billing_portal_url}
            action={action} />;
    }

    let message = '';
    switch (action) {
        case 'create_new':
        case 'create_new_has_canceled':
            message = 'Ask your parent to subscribe to continue using Learnforest';
            break;
        case 'end_trial':
        case 'increase_quantity':
        case 'increase_quantity_trial':
            message = 'Ask your parent to subscribe to continue using Learnforest';
            break;
        case 'decrease_quantity':
            break;
        case 'update_payment_past_due':
            message = 'Ask your parent to login since the Learnforest subscription is past due.';
            break;
        case 'update_payment_unpaid':
            message = 'Ask your parent to login since the Learnforest subscription is unpaid.';
            break;
        case 'none':
        default:
            break;
    }

    return <PaywallBanner message={message} action={action} />;
}

function UpdatePaymentBanner({ message, url, action }) {
    useEffect(() => {
        track('feature_blocked', { feature: 'video_playback', reason: 'paywall' });
    }, [action]);

    return <div className="border border-red-500 border-2 p-6 mb-8">
        <div className="mb-4">{message}</div>
        <a href={url}
            target="_blank" rel="noopener noreferrer"
            className="bg-blue-500 text-white py-2 px-4 rounded cursor-pointer">
            Update payment
        </a>
    </div>;
}

function PaywallBanner({ message, action }) {
    useEffect(() => {
        if (message) {
            track('feature_blocked', { feature: 'video_playback', reason: 'paywall' });
        }
    }, [message, action]);

    if (message) {
        return <div className="border border-red-500 border-2 p-6 mb-8">
            <div className="mb-4">{message}</div>
            <a href={process.env.REACT_APP_LF_PARENT_URL}
                target="_blank" rel="noopener noreferrer"
                className="bg-blue-500 text-white py-2 px-4 rounded cursor-pointer">
                Parent login
            </a>
        </div>;
    }

    return '';
}

export default SubscriptionActionBanner;
